import { useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { changeWithdrawalAccountBalance, changeWithdrawalAmount, changeWithdrawalFormStatus, clearWithdrawalForm, selectWithdrawalAccount, selectWithdrawalAccountBalance, selectWithdrawalAmount, selectWithdrawalFormStatus, selectWithdrawalValidAmountCheck, setConfirmingWithdrawal, setWithdrawalAccount, withdrawalIsConfirming } from "./withdrawalFormSlice";
import { changeSelectedBranch, loadAccountsByBank, selectAccounts, selectCurrentBranch } from "../manageAccounts/accountsSlice";
import { loadBranches, selectBranches } from "../manageBranches/branchesSlice";
import { addTransaction, addTransactionPending, clearNewTransaction } from "../transactionList/transactionsSlice";
import { isLoggedIn, selectToken } from "../login/loginSlice";
import { useNavigate } from "react-router-dom";
import { selectUser } from "../home/userSlice";
import Select from "react-select";

export default function WithdrawalForm() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector(selectToken);
    const loggedIn = useSelector(isLoggedIn);
    const userInfo = useSelector(selectUser);
    const userRole = userInfo.userRole;
    const bankId = userInfo.bankId;

    const confirmingWithdrawal = useSelector(withdrawalIsConfirming);
    const selectedBranch = useSelector(selectCurrentBranch);
    const branches = useSelector(selectBranches);

    const withdrawalAccount = useSelector(selectWithdrawalAccount);
    const withdrawalAmount = useSelector(selectWithdrawalAmount);
    const withdrawalAccountBalance = useSelector(selectWithdrawalAccountBalance);
    const withdrawalIsValidAmount = useSelector(selectWithdrawalValidAmountCheck);
    const withdrawalFormStatus = useSelector(selectWithdrawalFormStatus);

    const addingTransaction = useSelector(addTransactionPending);

    const accounts = useSelector(selectAccounts);
    let accountsOptions = [{
        value: "blank", label: "-- select --"
    }]
    Object.values(accounts).forEach(account => {
        if (selectedBranch === 'blank' || account.branchId === selectedBranch) {
            accountsOptions.push({
                value: account.accountId,
                label: `${account.username} | ${account.accountType} | **${account.accountId.slice(-4)}`
            })
        }
    })

    useEffect(() => {
        if (!loggedIn) {
            navigate(`../login`);
        }
    }, [loggedIn, navigate])

    useEffect(() => {
        if (userRole !== 'USER') {
            dispatch(loadBranches({bankId, token}));
            dispatch(loadAccountsByBank({bankId, token}));
        }
    }, [userRole, bankId, dispatch, token])

    useEffect(() => {
        dispatch(setConfirmingWithdrawal(false));
        dispatch(clearWithdrawalForm());
        dispatch(clearNewTransaction());
    }, [dispatch])

    useEffect(() => {
        if (withdrawalAccount.value !== "blank") {
            const newWithdrawalAccountBalance = Object.values(accounts).length ? Object.values(accounts).filter(account => account.accountId === withdrawalAccount.value)[0].balance.toFixed(2) : "";
            dispatch(changeWithdrawalAccountBalance(newWithdrawalAccountBalance));
        }
        
    }, [accounts, dispatch, withdrawalAccount])

    const handleSelectedBranchChange = event => {
        dispatch(changeSelectedBranch(event.target.value));
    }

    const handleWithdrawalAccountChange = option => {
        dispatch(setWithdrawalAccount(option));
    }

    const handleWithdrawalAmountChange = event => {
        const payload = {
            withdrawalAmount: event.target.value,
            validAmountCheck: Number(event.target.value) || event.target.value === '0'
        }
        dispatch(changeWithdrawalAmount(payload));
    }

    const handleWithdrawButtonClick = event => {
        event.preventDefault();

        if (withdrawalAccount === 'blank') {
            dispatch(changeWithdrawalFormStatus(`Please select a withdrawal account`));
        } else if (!(withdrawalAmount > 0) || typeof Number(withdrawalAmount) !== 'number') {
            dispatch(changeWithdrawalFormStatus(`Withdrawals must be a number greater than 0`));
        } else if (Number(withdrawalAmount) > Number(withdrawalAccountBalance)) {
            dispatch(changeWithdrawalFormStatus("Insufficient funds."));
        } else {
            dispatch(setConfirmingWithdrawal(true));
        }
    }

    const handleCancelButtonClick = event => {
        event.preventDefault();
        dispatch(setConfirmingWithdrawal(false));
    }

    const handleSubmit = event => {
        event.preventDefault();

        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const day = date.getDate() < 10 ? `0${date.getDate() + 1}` : date.getDate();
        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
        const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
        const transactionDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        const description = `Teller Withdrawal`;
        const withdrawalTransaction = {
            accountId: withdrawalAccount.value,
            type: `debit`,
            description,
            amount: withdrawalAmount,
            transactionDate: transactionDate
        }

        dispatch(addTransaction({transaction: withdrawalTransaction, token}));
        navigate(`../${bankId}/withdrawal/confirmation`);
    }

    return (
        <main>
            <Sidebar />
            <section>
                <h2>{confirmingWithdrawal ? "Confirm Withdrawal" : "Withdraw Money"}</h2>
                <form id="withdrawal">
                    {confirmingWithdrawal ? "" :
                    <label>
                        <h3>Select Branch</h3>
                        <select name="select-branch" onChange={handleSelectedBranchChange} value={selectedBranch}>
                            <option id="blank" key="blank" value="blank">-- select --</option>
                            {branches.map(branch => {
                                return <option id={branch.branchId} key={branch.branchId} value={branch.branchId}>{branch.branchName}</option>
                            })}
                        </select>
                    </label>}
                    {confirmingWithdrawal ? <p><span>Withdrawal Account:</span> {Object.values(accounts).map(account => account.accountId === withdrawalAccount ? `${account.accountType} ${account.accountId}` : "")}</p> :
                    <label htmlFor="withdrawal-account">
                        <h3>Withdrawal Account</h3>
                        <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                value={withdrawalAccount}
                                onChange={handleWithdrawalAccountChange}
                                options={accountsOptions}
                                placeholder="Select a withdrawal account..."
                                unstyled={true}
                            />
                    </label>}
                    {confirmingWithdrawal ? "" : 
                        withdrawalAccount.value !== "blank" ? <p><span>Current Balance:</span> ${withdrawalAccountBalance}</p> : ""
                    }
                    {confirmingWithdrawal ? <p><span>Withdrawal Amount:</span> ${Number(withdrawalAmount).toFixed(2)}</p> : 
                    <label htmlFor="withdrawal-amount">
                        <h3>Withdrawal Amount</h3>
                        <div className="amount-field">
                            <p className="dollar-sign">$</p>
                            <input name="withdrawal-amount" onChange={handleWithdrawalAmountChange} value={withdrawalAmount}></input>
                        </div>
                        {withdrawalIsValidAmount ? "" : <p className="error">Withdrawal amount must be a number.</p>}
                    </label>}
                    <p className={withdrawalFormStatus === 'Withdrawal successfully submitted' ? "confirmation" : "error"}>{withdrawalFormStatus}</p>
                    <div className="button-container">
                        {confirmingWithdrawal ? <button onClick={handleCancelButtonClick}>Cancel</button> : ""}
                        {confirmingWithdrawal ? <button onClick={handleSubmit} disabled={addingTransaction}>{addingTransaction ? "Processing Withdrawal..." : "Submit Withdrawal"}</button> : <button onClick={handleWithdrawButtonClick}>Withdraw Money</button>}
                    </div>
                </form>
            </section>
        </main>
    )
}